export default {
  title: 'Clés API',
  description:
    "Des clés qui permettent à un serveur d'agir pour cette organisation. Une clé appartient à l'organisation, pas à la personne qui l'a créée.",
  table: {
    title: 'Clés',
    search: 'Rechercher des clés...',
    name: 'Nom',
    prefix: 'Préfixe',
    permissions: 'Permissions',
    noPermissions: 'Aucune',
    created: 'Créée',
    lastUsed: 'Dernière utilisation',
    expires: 'Expire',
    grantedTo: 'Accordée à {name}',
  },
  empty: {
    title: 'Aucune clé API',
    description: 'Créez une clé pour connecter un serveur à cette organisation.',
  },
  create: {
    button: 'Créer une clé',
    title: 'Créer une clé API',
    name: 'Nom de la clé',
    namePlaceholder: 'Déploiement CI',
    nameHint: 'À quoi sert la clé, pour la reconnaître dans la liste',
    nameRequired: 'La clé doit avoir un nom',
    nameTooLong: '{max} caractères au maximum',
    expiration: 'Expiration',
    expirationHint: 'Quand cette clé doit-elle cesser de fonctionner ?',
    noExpiration: "Pas d'expiration",
    days30: '30 jours',
    days60: '60 jours',
    days90: '90 jours',
    year1: '1 an',
    permissions: 'Ce que la clé peut faire',
    permissionsHint:
      "La clé ouvre l'API publique pour l'organisation, avec ces permissions et aucune autre. Sans permission, elle n'ouvre rien.",
    submit: 'Créer la clé',
  },
  created: {
    title: 'Clé créée',
    description: 'Copiez la clé maintenant : elle ne s’affiche qu’une fois et ne pourra plus être lue.',
    copied: 'Clé copiée dans le presse-papiers',
    copy: 'Copier la clé',
    done: 'Terminé',
  },
  card: {
    prefix: 'Préfixe',
    createdBy: 'Créée par',
    created: 'Créée',
    lastUsed: 'Dernière utilisation',
    expires: 'Expire',
    never: 'Jamais',
    neverUsed: 'Jamais utilisée',
    revoke: 'Révoquer',
  },
  revoke: {
    title: 'Révoquer cette clé',
    description: 'Tout ce qui utilise « {name} » cesse immédiatement de s’authentifier. Cette action est irréversible.',
    confirm: 'Révoquer la clé',
    revoked: 'Clé révoquée',
    failed: "La clé n'a pas pu être révoquée. Réessayez.",
  },
  errors: {
    invalid: 'Cette clé ne peut pas être créée : vérifiez son nom et son expiration.',
    forbidden: "Vous n'avez pas le droit de créer des clés API dans cette organisation.",
    createFailed: "La clé n'a pas pu être créée. Réessayez.",
  },
}
